export const BEACON_EVENT = 'beacon';

export const COMSCORE_IDS = {
  prod: '6036206',
  dev: '0000000',
} as const;

export const PAGEVIEW_API_BY_HOSTNAME: Record<string, string> = {
  'hotpads.com': 'https://hotpads.com/hotpads-api/',
  'www.zillow.com': 'https://www.zillow.com/rental-manager-api/',
};

export const PAGEVIEW_CANDIDATE = 'pageview_candidate';

export const COMSCORE_KEYWORD = 'comscorekw=rentals';

export const DATA_CONSENT_ID = '2Aq73zwm0JDZ4IvqG0qudn';
